// src/data/exercises/L1_01.js

const accountOptions = [
  '資本金', '当座預金', '現金', '普通預金', '有価証券'
];

export const L1_01 = {
  title: '簿記　3級（第217-1回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          { type: 'ruby', text: '株式会社設立', ruby: 'かぶしきがいしゃせつりつ' },
          { type: 'text', value: 'に' },
          { type: 'ruby', text: '際', ruby: 'さい' },
          { type: 'text', value: 'し，' },
          { type: 'ruby', text: '株式', ruby: 'かぶしき' },
          { type: 'text', value: '190' },
          { type: 'ruby', text: '株', ruby: 'かぶ' },
          { type: 'text', value: 'を＠￥50,000で' },
          { type: 'ruby', text: '発行', ruby: 'はっこう' },
          { type: 'text', value: 'し，' },
          { type: 'ruby', text: '全額', ruby: 'ぜんがく' },
          { type: 'text', value: 'の' },
          { type: 'ruby', text: '払', ruby: 'はら' },
          { type: 'text', value: 'い' },
          { type: 'ruby', text: '込', ruby: 'こ' },
          { type: 'text', value: 'みを受け，これを' },
          { type: 'ruby', text: '当座預金', ruby: 'とうざよきん' },
          { type: 'text', value: 'とした。' },
        ],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '当座預金', debitAmount: 9500000, creditAccount: '資本金', creditAmount: 9500000 },
      ],
      explanation_correct: {
        parts: [
          { type: 'text', value: '「株式会社設立　株式　発行」なので、\n' },
          { type: 'text', value: '①資本金の増加（プラス）です。\n' },
          { type: 'styled', value: '資本金は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「全額の払い込みを受け、当座預金とした」なので、\n' },
          { type: 'text', value: '②当座預金の増加（プラス）です。\n' },
          { type: 'styled', value: '当座預金は借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
      },
      hints: {
        // Chỉ giữ lại gợi ý cho lỗi sai tài khoản
        account: [
          // Lần sai 1, 2
`「株式会社設立　株式　発行」なので、
①資本金の増加（プラス）です。

全額の払い込みを受け、当座預金とした」なので、
②当座預金の増加（プラス）です。`,
          // Lần sai 3 trở đi
          {
           parts: [
             { type: 'text', value: '「株式会社設立　株式　発行」なので、\n' },
             { type: 'text', value: '①資本金の増加（プラス）です。\n' },
             { type: 'styled', value: '資本金は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
             { type: 'text', value: '「全額の払い込みを受け、当座預金とした」なので、\n' },
             { type: 'text', value: '②当座預金の増加（プラス）です。\n' },
             { type: 'styled', value: '当座預金は借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
           ]
          }
        ],
        // Đã xóa hints cho 'amount' và 'structure'
      },
    },
  ],
};